import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  idTag: {
    ...theme.typography.body2,
    padding: '2px 8px',
    color: theme.colors.grey66,
    borderRadius: theme.borderRadius.full,
    backgroundColor: theme.colors.greyE8,
  },
}));

function IdTag({ children, className }) {
  const classes = useStyles();
  return <span className={`${classes.idTag} ${className}`}>ID {children}</span>;
}

IdTag.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

IdTag.defaultProps = {
  className: '',
};

export default IdTag;
